<template>
    <div class="timeline" v-if="actions.total" >
      <div class="timeline-line"></div>
        <div class="actions" @scroll="handleScroll"  ref="timelineContainer">
            <div v-for="(action, index) in actions.data" :key="index" class="timeline-item">
                <div class="action-icon">
                    <div class="icon" :class="getIconClass(action.action_type)">
                        <font-awesome-icon :icon="getIcon(action.action_type)" style="color: #fff;" />
                    </div>
                </div>
                <div class="content">
                    <span class="time">{{ formatDate(action.created_at) }}</span>
                    <p class="message">{{ action.details }}</p>
                    <span class="details">Performed by: {{ action.user.first_name }} {{ action.user.last_name }}</span>
                </div>
            </div>
      </div>
    </div>
    <div v-else>
      <p>No actions found.</p>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import { useStore } from 'vuex';
  
    export default {
        name: 'Actions',

        props: {
            leadId: {
                type: Number,
                required: true,
            },
        },
        setup(props) {
  
        const store = useStore();
        const actions = ref([]);
        const page = ref(1);
        const hasMore = ref(true);
        const loading = ref(false);
        const timelineContainer = ref(null);
        
        const fetchActions = async (isFromScroll) => {
            if (!hasMore.value || loading.value) return;
            loading.value = true;
    
            await store.dispatch("leads/fetchLeadActions", { leadId: props.leadId, page: page.value });
            const response = store.getters['leads/getLeadActions'];
    
            if (response.data.length === 0) {
                hasMore.value = false;
            }
    
            if (isFromScroll) {
                actions.value.data.push(...response.data);
            } else {
                actions.value = response;
            }
    
            if (response.current_page < response.last_page) {
                page.value++;
            } else {
                hasMore.value = false;
            }
    
            loading.value = false;
        };
        
        const handleScroll = () => {
            if (!timelineContainer.value) return;
            const { scrollTop, scrollHeight, clientHeight } = timelineContainer.value;
            if (scrollTop + clientHeight >= scrollHeight - 50) {
                fetchActions(true);
            }
        };
        
        onMounted(() => {
            fetchActions(false);
        });
        
        const formatDate = (date) => {
            return new Date(date).toLocaleString();
        };
        
        const getIcon = (actionType) => {
            switch (actionType) {
            case 'update lead':
                return 'fas fa-edit';
            case 'create lead':
                return 'fas fa-plus-circle';
            case 'delete lead':
                return 'fas fa-trash-alt';
            case 'create comment':
                return 'fa-solid fa-comment';
            default:
                return 'fas fa-info-circle';
            }
        };
        
        const getIconClass = (actionType) => {
            switch (actionType) {
            case 'update lead':
                return 'update';
            case 'create lead':
                return 'create';
            case 'delete lead':
                return 'delete';
            case 'create comment':
                return 'comment';
            default:
                return 'default';
            }
        };
        return {
            store ,
            hasMore,
            actions,
            getIconClass,
            getIcon,
            formatDate,
            page,
            handleScroll,
            fetchActions,
            timelineContainer,
            loading,
        }
    }
}
  </script>
  
  <style lang="scss">
  .timeline {
    display: flex;
    margin: auto;
    max-height: 400px;
    padding: 0px;
    position: relative;
    .actions{
        max-height: 400px;
        overflow-y: scroll;
        display: flex;
        flex-direction: column;
    }
  }

  .timeline-line {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 15px;
    width: 3px;
    height: 100%;
    background-color: #c4e4ff;
    border-radius: 5px;
  }

  
  .timeline-item {
    display: flex;
    margin-bottom: 20px;
    position: relative;
  }
  .action-icon{
        width: 40px;
        height:40px;
      .icon {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 14px;
        margin-right: 10px;
      }
  }
  
  .icon.update {
    background-color: #007bff;
  }
  
  .icon.create {
    background-color: #28a745;
  }
  
  .icon.delete {
    background-color: #dc3545;
  }
  
  .icon.default {
    background-color: #6c757d;
  }
  .icon.comment{
    background-color: #ff6700;
  }
  .content {
    padding: 0px 10px;
    border-radius: 5px;
    flex-grow: 1;
  }
  
  .time {
    font-weight: bold;
    color: #333;
    display: block;
    font-size: 14px;
  }
  
  .message {
    margin: 5px 0;
    color: #000;
    font-size: 14px;
  }
  
  .details {
    font-size: 12px;
    color: #777;
  }
  </style>
